import { useEffect, useState } from 'react';

import FeaturedSlides from '../Components/FeaturedSlides';
import { useNotification } from '../Contexts/NotificationContext';

const HomeFeatureds = () => {
    const { setNotification } = useNotification();
    const [featureds, setFeatureds] = useState([]);
    const [loading, setLoading] = useState(true);

    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchFeatureds = async () => {
            try {
                const response = await fetch(`${baseUrl}/painel/destaques?page=1&per_page=8`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                if (response.ok) {
                    const data = await response.json();

                    const todosDestaques = [...(data.ultimo_destaque ? [data.ultimo_destaque] : []), ...(data.destaques || [])];

                    setFeatureds(todosDestaques);
                } else {
                    throw new Error('Erro ao buscar os destaques');
                }
            } catch (error) {
                setNotification({
                    type: 'error',
                    message: error.message,
                    show: true,
                });
            } finally {
                setLoading(false);
            }
        };

        fetchFeatureds();
    }, []);

    return <FeaturedSlides content={featureds} title="Destaques da Rometal" loading={loading} />;
};

export default HomeFeatureds;
